// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-Topline-GeoPopup-styles--root--R9DCM {
  box-sizing: border-box;
  z-index: 100;
}

.src-components-Topline-GeoPopup-styles--root--R9DCM * {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/Topline/GeoPopup/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".root {\n  box-sizing: border-box;\n  z-index: 100;\n}\n\n.root * {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-Topline-GeoPopup-styles--root--R9DCM`
};
module.exports = ___CSS_LOADER_EXPORT___;
